import { GeofenceVehicleOutputWithStatus } from './geofence-vehicle-output-with-status.model';


export class GeofenceVehicleSelectByIdOutput implements IGeofenceVehicleSelectByIdOutput {
    status!: number;
    message!: string;
    data!: GeofenceVehicleOutputWithStatus;

    constructor(data?: IGeofenceVehicleSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? GeofenceVehicleOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeofenceVehicleSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceVehicleSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGeofenceVehicleSelectByIdOutput {
    status: number;
    message: string;
    data: GeofenceVehicleOutputWithStatus;
}

